import { useEffect, useState } from "react";
import { UserRole, UserTransport } from "src/app/transports/user";
import { UserModel } from "src/app/types/UserModel";
import { useAuth } from "src/app/utils/useAuth";

const useUserListByRole = (
    roles: Array<UserRole>,
    action?: "withCurrentUser" | "onlyCurrentUser" | ""
) => {
    const { currentUser } = useAuth();
    const [userListByRole, setUserListByRole] = useState<Array<UserModel>>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    useEffect(() => {
        setLoading(true);
        UserTransport.listByRoles({ roles, isActive: 1 })
            .then((res) => {
                switch (action) {
                    case "onlyCurrentUser":
                        setUserListByRole([currentUser]);
                        break;
                    case "withCurrentUser":
                        setUserListByRole([currentUser].concat(res));
                        break;
                    default:
                        setUserListByRole(res);
                }
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    }, []);

    return { userListByRole, loading, error };
};
export default useUserListByRole;
